export default __webpack_public_path__ + "static/media/013.e877348c.jpg";